import { editXuserChannel } from '@/service/vbef'
import store from '@/store'
const state = store.state
const SHARECHANNEL_STORAGE_KEY = 'sharechannel'

const normalizeShareChannelId = (value) => {
  const channelId = Number(value)
  return Number.isFinite(channelId) && channelId > 0 ? channelId : 0
}

const getLocalShareChannelId = (storageKey = SHARECHANNEL_STORAGE_KEY) => {
  if (typeof window === 'undefined' || !window.localStorage) return 0
  try {
    return normalizeShareChannelId(window.localStorage.getItem(storageKey))
  } catch (e) {
    return 0
  }
}

const setLocalShareChannelId = (value, storageKey = SHARECHANNEL_STORAGE_KEY) => {
  if (typeof window === 'undefined' || !window.localStorage) return
  try {
    const channelId = normalizeShareChannelId(value)
    if (!channelId) return
    window.localStorage.setItem(storageKey, String(channelId))
  } catch (e) {}
}

const editXuserChannelByShareChannelId = (actId, channelId) => {
  const normalizedChannelId = normalizeShareChannelId(channelId)
  if (!normalizedChannelId) return Promise.resolve(null)
  return editXuserChannel({
    actId,
    channelId: state.language == 'zh' && normalizedChannelId == 203 ? 204 : normalizedChannelId,
  })
}

const editXuserChannelByLocalShareChannelId = (actId, storageKey = SHARECHANNEL_STORAGE_KEY) => {
  return editXuserChannelByShareChannelId(actId, getLocalShareChannelId(storageKey))
}

export {
  getLocalShareChannelId,
  setLocalShareChannelId,
  editXuserChannelByShareChannelId,
  editXuserChannelByLocalShareChannelId,
}
